export const StorageKey = 'app-config';
